<template>
  <div>
    <div class="ft-22-333">统计分析</div>
    <el-empty
      v-if="statisticList.length === 0"
      description="暂无数据"
    ></el-empty>
    <div class="se-list">
      <div
        class="se-item se-p-t-35 se-p-b-35 se-bor-b se-flex jcsb"
        v-for="(item, index) in statisticList"
        :key="index"
      >
        <div>
          <div class="ft-18-333">{{ item.courseName }}</div>
          <div class="se-flex aic ft-14-666 se-p-t-20 se-p-b-20">
            <div>点击量：{{ item.totalClickCount }}</div>
            <div class="se-dot"></div>
            <div>平均浏览时长：{{ item.avgDuration }}</div>
            <div class="se-dot"></div>
            <div>浏览完毕量：{{ item.endNum }}</div>
            <div class="se-dot"></div>
            <div>评价数：{{ item.evaluateNum }}</div>
          </div>
          <el-rate v-model="item.star" disabled text-color="#ff9900"> </el-rate>
        </div>
        <div class="se-btn cp" @click="getInfo(item.courseId)">
          学员评价列表
        </div>
      </div>
    </div>
    <!-- 评价列表对话框 -->
    <el-dialog title="学员评价列表" :visible.sync="visible">
      <div class="se-list">
        <div class="se-item" v-for="(item, i) in styMyCourses" :key="i">
          <evaluate-item :item="item"></evaluate-item>
        </div>
        <div class="se-flex-h-c se-m-t-20">
          <el-pagination
            background
            @current-change="currentChange"
            :current-page="pageNum"
            :page-size="3"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import evaluateItem from "../../course-info/components/evaluateItem.vue";

export default {
  components: {
    // evaluateItem,
  },

  data() {
    return {
      pageNum: 1,
      star: 5,
      visible: false,
      currentPage: 1,
      statisticList: [],
      styMyCourses: [],
      total: 0,
      courseId: "",
      commentVisible: false,
    };
  },

  watch: {
    visible(value) {
      if (!value) {
        this.pageNum = 1;
        this.styMyCourses = [];
        this.total = 0;
      }
    },
  },

  created() {
    this.getStatisticList();
  },

  methods: {
    currentChange(val) {
      this.styMyCourses = [];
      this.pageNum = val;
      this.getCourseContentList();
    },
    getInfo(courseId) {
      this.courseId = courseId;
      this.getCourseContentList();
      this.visible = true;
    },
    getCourseContentList() {
      this.$http
        .get("server/portal/home/getCourseContent/" + this.courseId, {
          pageSize: 3,
          pageNum: this.pageNum,
        })
        .then((res) => {
          this.styMyCourses = res.data.styMyCourses;
          this.visible = [];
          this.total = res.data.total;
        });
    },

    // 展示学院评价列表
    isShow() {
      this.visible = true;
    },

    // 分页回调

    //统计分析
    getStatisticList() {
      let token = localStorage.getItem("token");
      this.$http
        .get(
          "server/portal/personCenter/statisticalChartList",
          {},
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          this.statisticList = res.rows;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.se-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #666666;
  margin: 0 15px;
}

.se-btn {
  width: 110px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #999999;
  border-radius: 5px;
}
</style>
